import { render } from "./slides.vue?vue&type=template&id=758591db"
import script from "./slides.vue?vue&type=script&lang=js"
export * from "./slides.vue?vue&type=script&lang=js"

import "./slides.vue?vue&type=style&index=0&id=758591db&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__